'use strict';

import CreditRequest from './../data_models/credit_request.model';
import ConnectorService from './../services/connector.service';

class CreditRequestService {
  async sendCreditRequest(enrollment) {
    // const courseBreakUp = [...enrollment._courseInfo._openEdxCourseId.split(':')[1].split('+')];

    return ConnectorService.postCreditRequest(
      new CreditRequest({
        enrollmentId: enrollment._enrollmentId,
        courseOrg: enrollment._courseInfo._courseOrg,
        courseNum: enrollment._courseInfo._courseNum,
        courseRun: enrollment._courseInfo._courseRun,
        enrollmentTimestamp: new Date(enrollment._enrollmentDate).getTime() / 1000,
        finalGrade: enrollment._grade,
        courseCompletionTimestamp: new Date(enrollment._courseCompletedDate).getTime() / 1000,
        username: ConnectorService.learnerData._asuRite,
        userEmail: ConnectorService.learnerData._emailId,
        userFullName: ConnectorService.learnerData._firstName + ' ' + ConnectorService.learnerData._lastName,
        lms: enrollment._courseInfo._lms
      })
    );
  }
}

export default new CreditRequestService();
